// 单选——主流程
const MainRoutes = Array.from({ length: 7 }, (_, i) => ({
  path: `module/radio/index${i + 1}`,
  name: `module/radioIndex${i + 1}`,
  component: () => import(`@/views/recognize/module/radio/index${i + 1}.vue`)
}))

export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 单选——主流程，开始
    ...MainRoutes
  ]
}
